import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { ApplicationSummary, Pagination, Organisation, UserInfo } from "../../../../models";
import { USERHOMECONSTANTS } from "../../userHome.constants";
import { CurrentUserService, UserAuthenticationService } from "../../../../services/shared";
import { AppInfoService } from "../appInfo.service";
import { ApplicationService } from "../applications.service";
import {NgProgressService} from "ng2-progressbar";

@Component({
    selector: "appInfo-component",
    template: require("./appInfo.component.html"),
    styles: [require("./appInfo.component.less").toString()],
    providers: [AppInfoService]
})

export class AppInfoComponent implements OnInit {
    @Input() applications: ApplicationSummary[];
    @Input() organisations: Organisation[]; 
    @Output() refreshApps: EventEmitter<any> = new EventEmitter();
    @Output() refreshOrgans: EventEmitter<any> = new EventEmitter();
    @Output() redirect: EventEmitter<any> = new EventEmitter();
    @Output() reloadMyhome: EventEmitter<any> = new EventEmitter();
    errorMessage: string;
    selectedOrganisationId: string;
    position: string;
    role: string;
    email: string;
    applicationsComponent = {
        sortColumnIndex: 1,
        sortOrder: USERHOMECONSTANTS.sorting.ascOrderString,
        sortColumn: "ApplicationName",
        pagination: new Pagination()
    };

    constructor(private pService: NgProgressService, private currentUserService: CurrentUserService, private netIdRouter: Router,
        private applicationService: ApplicationService, private userAuthService: UserAuthenticationService, private appInfoService: AppInfoService) {
        this.applicationsComponent.pagination = {
            totalItems: 0,
            currentPage: USERHOMECONSTANTS.pagination.currentPage,
            itemsPerPage: USERHOMECONSTANTS.pagination.itemsPerPage,
            maxSize: USERHOMECONSTANTS.pagination.maxSize
        };
    }

    public ngOnInit() {
        this.pService.start();
        if (this.currentUserService.token) {
            this.GetApplications(this.currentUserService.userInfo.organisation);
            this.GetOrganisations();
        }
        this.pService.done();
    }

    public PageChanged(currentPageObject) {
        this.pService.start();
        this.applicationsComponent.pagination.currentPage = currentPageObject.page;
        let organisation = this.organisations.find(o => o.extOrganisationId === this.selectedOrganisationId);
        this.GetApplications(organisation);
        this.pService.done();
    }

    public SortIconClass(columnIndex): string {
        if (columnIndex === this.applicationsComponent.sortColumnIndex) {
            if (this.applicationsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                return USERHOMECONSTANTS.sorting.ascIconClass;
            } else {
                return USERHOMECONSTANTS.sorting.descIconClass;
            }
        } else {
            return "";
        }
    }

    public OnAppWarning(): void {
        this.redirect.emit(1);
    }

    public OnAppClick(url: string): void {
        if (url.indexOf("elearning") !== -1) {
            this.appInfoService.GetGetElearningUrl()
                .subscribe(appUrl => {
                    this.netIdRouter.navigate(["/"]).then(result => { window.location.href = appUrl; });
                });
        } else {
            this.netIdRouter.navigate(["/"]).then(result => { window.location.href = url; });
        }
    }

    public OnAppNameClick(applicationId: string, url: string): void {
        let natWindow = window.open();
        if (url.indexOf("elearning") !== -1) {
            this.appInfoService.GetGetElearningUrl()
                .subscribe(appUrl => {
                    //natWindow.open(appUrl);
                    natWindow.location.href = appUrl;
                });
        } else {
            this.appInfoService.GetClientApplicationToken(applicationId)
                .subscribe(token => {
                    let appUrl = url.indexOf("?") !== -1 ? `${url}&q=${token}` : `${url}?q=${token}`;
                    //natWindow.open(appUrl);
                    natWindow.location.href = appUrl;
                });
        }
    }

    public SortList(columnIndex: number) {
        if (columnIndex === this.applicationsComponent.sortColumnIndex) {
            if (this.applicationsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                this.applicationsComponent.sortOrder = USERHOMECONSTANTS.sorting.descOrderString;
            } else {
                this.applicationsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            }
        } else {
            this.applicationsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            switch (columnIndex) {
                case 1:
                    this.applicationsComponent.sortColumn = "ApplicationName";
                    break;
                case 2:
                    this.applicationsComponent.sortColumn = "Roles";
                    break;
                case 3:
                    this.applicationsComponent.sortColumn = "FromDate";
                    break;
                case 3:
                    this.applicationsComponent.sortColumn = "ToDate";
                    break;
                default:
                    this.applicationsComponent.sortColumn = "ApplicationName";
            }
        }
        this.pService.start();
        this.applicationsComponent.sortColumnIndex = columnIndex;
        let organisation = this.organisations.find(o => o.extOrganisationId === this.selectedOrganisationId);
        this.GetApplications(organisation);
        this.pService.done();

    }

    public OrganisationChange(selectedOrganisation): void {

        // Refresh user access token
        this.userAuthService
            .ResetAccessToken(selectedOrganisation)
            .subscribe(
            (response) => {

                let organFound = this.organisations.find(o => o.extOrganisationId === selectedOrganisation);

                let userInfo = this.currentUserService.userInfo;
                userInfo.organisation = organFound;
                this.selectedOrganisationId = organFound.extOrganisationId;
                this.role = organFound.roleCode;
                this.position = organFound.jobTitle;
                this.email = organFound.email;
                this.applicationsComponent.pagination.currentPage = USERHOMECONSTANTS.pagination.currentPage;
                this.currentUserService.userInfo = userInfo;
                if (selectedOrganisation.toUpperCase() !== '0778F56A-70FB-4A32-94D9-151828E21287') {
                this.GetApplications(organFound);
                }
                this.reloadMyhome.emit();
            },
            (error) => {
                this.errorMessage = JSON.parse(error._body).error_description;
            });
    }

    private BuildOdataUrl(selectedOrganisation): string {

        let odataUrl = `$filter=(ApplicationStatusCode ne 'Archive')&`;
        // return only active applications
        if (!selectedOrganisation === undefined) {
            let odataUrl = `$filter=(ExtOrganisationId eq ${this.selectedOrganisationId} and ApplicationStatusCode ne 'Archive')&`;
        }

        return odataUrl;
    }

    public GetApplications(selectedOrganisation): void {

        let odataUrl = this.BuildOdataUrl(selectedOrganisation);
        this.applicationService
            .GetApplicationList(this.applicationsComponent.pagination, this.applicationsComponent.sortOrder, this.applicationsComponent.sortColumn, odataUrl)
            .map(response => response.json())
            .subscribe(
            response => {
                this.applicationService.confirmTotalItemUpdate(response.count);
                this.applicationsComponent.pagination.totalItems = response.count;
                this.refreshApps.emit(<ApplicationSummary[]>response.result);
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }

    private GetOrganisations(): void {
        var _app = this;//using this wrapper for debugging when in a subscriber function. 
        this.applicationService
            .GetOrganisations()
            .subscribe(
            (response: Organisation[]) => {
                this.refreshOrgans.emit(response);
                if (!_app.selectedOrganisationId) {
                    if (!_app.currentUserService.userInfo.organisation.extOrganisationId) {//added check against orgID as check against org was returning true although no org had been selected.
                        let organ = response.find(o => o.isMain === true);
                        _app.selectedOrganisationId = organ.extOrganisationId;
                        _app.role = organ.roleCode;
                        _app.position = organ.jobTitle;
                        _app.email = organ.email;
                        let userInfo = new UserInfo();
                        userInfo.organisation = new Organisation();
                        userInfo.organisation = organ;
                        _app.currentUserService.userInfo = userInfo;
                    }
                    else {
                        _app.selectedOrganisationId = _app.currentUserService.userInfo.organisation.extOrganisationId;
                        _app.role = _app.currentUserService.userInfo.organisation.roleCode;
                        _app.position = _app.currentUserService.userInfo.organisation.jobTitle;
                        _app.email = _app.currentUserService.userInfo.organisation.email;
                    }
                }
            },
            (error) => {
                let parsedErrors = JSON.parse(error._body);
                if (parsedErrors) {
                    this.errorMessage = parsedErrors.message;
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/userHome/applications/appInfo/AppInfo.component.ts